import React, { Component } from 'react';
import Employee from '../../containers/admin/employee/index'
import User from '../../containers/admin/users/index'
import AttendanceReport from '../../containers/admin/attendanceReport/index'
import LeaveReport from '../../containers/admin/leaveReport/index'
import Holidays from '../../containers/employees/holidays/index'
import TaxSavingType from '../../containers/admin/taxSavingTypes.js/index'
import EmailTemplet from '../../containers/admin/emailTemplet/index'
import Containers from '../../containers/admin/containers/index'
import MapEmployee from '../../containers/admin/mapEmployee/index'
import { Link, HashRouter, Route, Redirect, NavLink } from 'react-router-dom'
import { getAdminUser } from '../../actions/adminAction'
import { bindActionCreators } from 'redux';
import AppConfig from '../../appConfig';
import { connect } from 'react-redux';


class Index extends Component {
    render() {
        const userRole = this.props.dashboardData.userRole
        return (
            <div>
                <HashRouter>
                    {userRole == "Admin" && <div>
                        <div className="secondary-navbar">
                            <span><NavLink exact to={AppConfig.baseUrl + 'Admin'} className={"nav-link"}>USERS</NavLink></span>
                            <span><NavLink to={AppConfig.baseUrl + 'Admin/Employee'} className={"nav-link"}>EMPLOYEES</NavLink></span>
                            <span><NavLink to={AppConfig.baseUrl + 'Admin/AttendanceReport'} className={"nav-link"}>ATTENDANCE REPORT</NavLink></span>
                            <span><NavLink to={AppConfig.baseUrl + 'Admin/LeaveReport'} className={"nav-link"}>LEAVE REPORT</NavLink></span>
                            {/* <span><NavLink to={AppConfig.baseUrl + 'Admin/EmailTemplates'}>EMAIL TEMPLATES</NavLink></span> */}
                            {/* <span><NavLink to={AppConfig.baseUrl + 'Admin/Containers'}>CONTAINERS</NavLink></span> */}
                            <span><NavLink to={AppConfig.baseUrl + 'Admin/ManageHolidays'} className={"nav-link"}>HOLIDAYS</NavLink></span>
                            <span><NavLink to={AppConfig.baseUrl + 'Admin/ManageTaxSavingTypes'} className={"nav-link"}>TAX SAVINGS TYPES</NavLink></span>
                            <span><NavLink to={AppConfig.baseUrl + 'Admin/MapEmployee'} className={"nav-link"}>MAP EMPLOYEE</NavLink></span>
                        </div>
                        <div>
                            <Route path={AppConfig.baseUrl + 'Admin'} exact strict render={() => { return (<User adminData={this.props.adminData} />) }} />
                            <Route path={AppConfig.baseUrl + 'Admin/Employee'} exact strict render={() => { return (<Employee adminData={this.props.adminData} employeeData={this.props.employeeData} />) }} />
                            <Route path={AppConfig.baseUrl + 'Admin/AttendanceReport'} exact strict render={() => { return (<AttendanceReport adminData={this.props.adminData} />) }} />
                            <Route path={AppConfig.baseUrl + 'Admin/LeaveReport'} exact strict render={() => { return (<LeaveReport adminData={this.props.adminData} leaveUser={'Admin'} />) }} />
                            {/* <Route path={AppConfig.baseUrl + 'Admin/EmailTemplates'} exact strict render={() => { return (<EmailTemplet adminData={this.props.adminData} />) }} /> */}
                            {/* <Route path={AppConfig.baseUrl + 'Admin/Containers'} exact strict render={() => { return (<Containers />) }} adminData={this.props.adminData} /> */}
                            <Route path={AppConfig.baseUrl + 'Admin/ManageHolidays'} exact strict render={() => { return (<Holidays action='displayAction' dashboardData={this.props.dashboardData} employeeData={this.props.employeeData} />) }} />
                            <Route path={AppConfig.baseUrl + 'Admin/ManageTaxSavingTypes'} exact strict render={() => { return (<TaxSavingType adminData={this.props.adminData} />) }} />
                            <Route path={AppConfig.baseUrl + 'Admin/MapEmployee'} exact strict render={() => { return (<MapEmployee adminData={this.props.adminData} />) }} />
                        </div>
                    </div>}
                </HashRouter>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        dashboardData: state.dashboardData,
        adminData: state.adminData,
        employeeData: state.employeeData,
    }
}
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ getAdminUser }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(Index)
